export default __webpack_public_path__ + "static/29-60d07e545a50f3e4cd2a7ad1cd99ca59.png";